module.exports = __webpack_public_path__ + "img/cacc-occupational.68790462.jpg";